module.exports = __webpack_public_path__ + "static/media/Icon_ZoomIn.8ee7a1f2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/icons/svg/Icon_ZoomIn.svg
// module id = 2323
// module chunks = 0